// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Lyx4v","title":"styles_title__3nCgx"};